import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faCheck, faUser, faLink } from '@fortawesome/free-solid-svg-icons';
import { API } from '../API';
import { DIALOG_TYPES } from './ModalDialog';

const _api = Symbol();

class ForgotPassword extends BaseElement {
	constructor() {
		super();

		this.library.add(faCheck, faUser, faLink);
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					
				}
				
				.centered {
					display: flex;
					justify-content: center;
				}
				input {
					width: 10em;
					margin-right: 0.5em;
				}
				a {
					margin-top: 0.5em;
					font-size: 0.85em;
					display: block;
					text-align: right;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	async handleSubmit(e) {
		try {
			e.preventDefault();
			if(!this.api)
				throw new Error('api property not set!');
			
			const detail = Object.fromEntries(new FormData(e.target));
			e.target.reset();
			const { username } = detail;
			const response = await this.api.sendPasswordReset(username);
			this.emit('show-dialog', {
				title: 'Password Reset Request',
				message: response,
				type: DIALOG_TYPES.DIALOG_TYPE_INFO
			});
		}
		catch(err) {
			this.emit('show-dialog', {
				title: 'Auth Service Error',
				message: err instanceof TypeError ? 'Failed to connect to authentication service.' : err.message,
				type: DIALOG_TYPES.DIALOG_TYPE_ERROR
			});
		}
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api = null;
	}
	render() {
		return html`
			<h4>Account password recovery</h4>
			<p>
				Please enter your account username. A password recovery email will be sent to your account's registered email.
			</p>
			<div class="centered">
				<div>
					<form @submit="${e => this.handleSubmit(e)}">
						<input type="text" name="username" placeholder="Username" name=""/>
						<button type="submit">
							<i class="icon fas fa-check"></i>
							Submit
						</button>
					</form>
					<a href="/forgot-username">Forgot your username?</a>
				</div>
			</div>
		`;
	}
}

customElements.define('pp-forgot-password', ForgotPassword);